import FmdGoodIcon from '@mui/icons-material/FmdGood'
import { ReactComponent as Arrow } from 'assets/icons/chevronBlue.svg'
import { SavedAddress } from 'feature/addresses/redux/MyAddresses.api'
import { SetStateAction } from 'react'
import { Button } from 'ui'

import style from './UserAddressButton.module.scss'

type TUserAddressButton = {
  userAddressClick: ((address: SavedAddress) => void) | undefined
  item: SavedAddress
  setUserAddressVisible: (value: SetStateAction<boolean>) => void
}

export const UserAddressButton = ({
  userAddressClick,
  item,
  setUserAddressVisible,
}: TUserAddressButton) => {
  return (
    <Button
      onClick={() => {
        if (userAddressClick) userAddressClick(item)
        setUserAddressVisible(false)
      }}
      className={style.personalAddressItem}
      data-testid={`dadata-user-address-${item.fiasId}`}
    >
      <div className={style.address}>
        <FmdGoodIcon color='primary' />
        <span>{item.address}</span>
      </div>

      <Arrow />
    </Button>
  )
}
